import {
  modifyContractTerms,
  receiveContractTerms,
  setContractTermsIsBusy,
  closeContractTerms
} from './contract-terms.actions';
import itemReducer from '../../../items/item.reducers';

const contractTermsReducer = itemReducer(
  receiveContractTerms,
  setContractTermsIsBusy,
  modifyContractTerms,
  closeContractTerms
);

export default contractTermsReducer;
